class ContactFormConfirmation {
  constructor() {
    this.form = document.getElementById('ContactForm');
    this.confirmOverlay = document.getElementById('confirmation-overlay');
    this.confirmTable = document.getElementById('confirm-table');
    this.backButton = document.getElementById('back-button');
    this.confirmButton = document.getElementById('confirm-button');
    
    this.formData = {};
    this.isConfirmed = false;
    
    if (this.form) {
      this.init();
    }
  }

  init() {
    // 元の送信ボタンを取得（複数の方法を試す）
    this.originalSubmitButton = this.form.querySelector('button[type="submit"]') || 
                                this.form.querySelector('input[type="submit"]');
    
    console.log('送信ボタン:', this.originalSubmitButton);
    
    // 元の送信ボタンのテキストを変更
    if (this.originalSubmitButton) {
      this.originalSubmitButton.textContent = '確認画面へ';
    }

    // フォーム送信をインターセプト
    this.handleSubmitBound = this.handleSubmit.bind(this);
    this.form.addEventListener('submit', this.handleSubmitBound, true);

    // 戻るボタン
    if (this.backButton) {
      this.backButton.addEventListener('click', () => {
        this.hideConfirmation();
      });
    }

    // 送信ボタン
    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', () => {
        this.submitForm();
      });
    }
  }

  handleSubmit(e) {
    console.log('handleSubmit呼び出し, isConfirmed:', this.isConfirmed);
    
    // 確認済みの場合は送信を許可
    if (this.isConfirmed) {
      console.log('確認済み - フォーム送信を許可');
      this.isConfirmed = false;
      return true;
    }
    
    console.log('確認画面を表示するため、送信をブロック');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // バリデーションチェック
    if (!this.form.checkValidity()) {
      console.log('バリデーションエラー');
      this.form.reportValidity();
      return false;
    }
    
    this.showConfirmation();
    return false;
  }

  showConfirmation() {
    console.log('確認画面を表示');
    
    // フォームデータを収集
    this.collectFormData();
    
    // 確認テーブルを生成
    this.confirmTable.innerHTML = this.generateConfirmationTable();
    
    // オーバーレイを表示
    this.confirmOverlay.classList.add('active');
    
    // 元のフォームの送信ボタンを非表示
    this.form.classList.add('hide-submit-button');
    
    window.scrollTo(0, 0);
  }

  hideConfirmation() {
    console.log('確認画面を非表示');
    
    // オーバーレイを非表示
    this.confirmOverlay.classList.remove('active');
    
    // 元のフォームの送信ボタンを表示
    this.form.classList.remove('hide-submit-button');
    
    // 確認ボタンを再度有効化
    if (this.confirmButton) {
      this.confirmButton.disabled = false;
      this.confirmButton.textContent = 'この内容で送信する';
    }
    
    window.scrollTo(0, 0);
  }

  collectFormData() {
    const formData = new FormData(this.form);
    this.formData = {};
    
    for (let [key, value] of formData.entries()) {
      const match = key.match(/contact\[(.*?)\]/);
      if (match) {
        this.formData[match[1]] = value;
      } else if (key !== 'form_type' && key !== 'utf8') {
        this.formData[key] = value;
      }
    }
    
    console.log('収集したフォームデータ:', this.formData);
  }

  generateConfirmationTable() {
    const fieldLabels = {
      'お名前': 'お名前',
      'フリガナ': 'フリガナ',
      '会社名・団体名': '会社名・団体名',
      'email': 'メールアドレス',
      '電話番号': '電話番号',
      'お問い合わせ種別': 'お問い合わせ種別',
      'お問い合わせ内容': 'お問い合わせ内容'
    };

    const displayOrder = ['お名前', 'フリガナ', '会社名・団体名', 'email', '電話番号', 'お問い合わせ種別', 'お問い合わせ内容'];
    let html = '';

    displayOrder.forEach(key => {
      const value = this.formData[key];
      if (value && value.trim()) {
        const label = fieldLabels[key];
        const displayValue = key === 'お問い合わせ内容' 
          ? this.escapeHtml(value).replace(/\n/g, '<br>')
          : this.escapeHtml(value);
        
        html += `
          <tr class="contact-form-row">
            <td class="contact-form-label">
              ${this.escapeHtml(label)}
            </td>
            <td class="contact-form-input confirmation-value">
              ${displayValue}
            </td>
          </tr>
        `;
      }
    });

    return html;
  }

  submitForm() {
    console.log('送信処理開始');
    
    // ボタンを無効化
    if (this.confirmButton) {
      this.confirmButton.disabled = true;
      this.confirmButton.textContent = '送信中...';
    }

    // 確認済みフラグを設定
    this.isConfirmed = true;
    console.log('isConfirmedをtrueに設定');
    
    // オーバーレイを非表示
    this.confirmOverlay.classList.remove('active');
    
    // 元のフォームの送信ボタンを表示
    this.form.classList.remove('hide-submit-button');
    
    // 送信中メッセージを表示
    const submitSection = this.form.querySelector('.original-submit-section');
    if (submitSection) {
      submitSection.innerHTML = `
        <div style="text-align: center; padding: 2rem;">
          <div style="font-size: 1.6rem; font-weight: bold; margin-bottom: 1rem;">送信中...</div>
          <div style="font-size: 1.4rem; color: rgba(var(--color-foreground), 0.6);">
            しばらくお待ちください
          </div>
        </div>
      `;
    }
    
    // イベントリスナーを一時的に削除
    this.form.removeEventListener('submit', this.handleSubmitBound, true);
    
    console.log('フォームを送信します');
    console.log('フォームの action:', this.form.action);
    console.log('フォームの method:', this.form.method);
    
    // requestSubmitを使用（より推奨される方法）
    setTimeout(() => {
      try {
        if (this.form.requestSubmit) {
          console.log('requestSubmitを使用');
          this.form.requestSubmit();
        } else {
          console.log('通常のsubmitを使用');
          this.form.submit();
        }
      } catch (error) {
        console.error('送信エラー:', error);
        alert('送信に失敗しました。ページをリロードして再度お試しください。');
        // エラー時はイベントリスナーを再登録
        this.form.addEventListener('submit', this.handleSubmitBound, true);
        this.isConfirmed = false;
      }
    }, 300);
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return String(text).replace(/[&<>"']/g, function(m) { return map[m]; });
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', function() {
  console.log('ContactFormConfirmation初期化');
  new ContactFormConfirmation();
});